import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Button, Divider, Form, Input, message, Select, Space } from 'antd'
import { profileScreen } from '../../../../translates'
import { AppConfig } from '../../../../AppConfig'
import { useStores } from '../../../../Store/Store'
import { useTaxSystemsQuery } from '../../../../api/react-query/dict'

const { Option } = Select
export default function TaxSystemItem ({ form, isDisabled = false }) {
  const {
    partnerProfile: {
      profile
      // profile: {
      //   profileFormStatus
      // },
      // setPartnerProfile,
      // form: profileForm
    } = {}
  } = useStores()

  const isSzContent = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szContent
  }, [profile?.personalData?.roleCode])

  const isResearcher = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.researcher
  }, [profile?.personalData?.roleCode])

  const isSzOperator = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szOperator
  }, [profile?.personalData?.roleCode])

  const isSzMentor = useMemo(() => {
    return profile?.personalData?.roleCode === AppConfig.partnerRoles.szMentor
  }, [profile?.personalData?.roleCode])

  const {
    data: dataTaxSystems,
    isError: isErrorTaxSystems,
    // isSuccess: isSuccessTaxSystems,
    isLoading: isLoadingTaxSystems
  } = useTaxSystemsQuery({
    enabled: !(isSzContent || isResearcher || isSzOperator || isSzMentor)
  })

  const [taxSystemsList, setTaxSystemsList] = useState([])
  const [name, setName] = useState('')
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)

  useEffect(() => {
    const dropdown = document.getElementsByClassName('tax-system')
    const wrapper = wrapperRef?.current
    const handleClick = event => {
      !dropdown[0]?.contains?.(event?.target) && !wrapper?.contains?.(event?.target) && setOpen(false)
      // event.preventDefault()
    }
    document?.addEventListener('click', handleClick)
    document?.addEventListener('touchend', handleClick)
    return () => {
      document?.removeEventListener('click', handleClick)
      document?.removeEventListener('touchend', handleClick)
    }
  }, [])

  const onNameChange = (event) => {
    setName(event.target.value)
  }
  const addItem = (e) => {
    e.preventDefault()
    setTaxSystemsList(name ? [...dataTaxSystems?.result, name] : taxSystemsList)
    setName('')
    const values = form.getFieldValue('personalData')

    form.setFieldsValue({ personalData: { ...values, [profileScreen.input.taxSystem.name]: name } })
  }

  useEffect(() => {
    if (dataTaxSystems?.result) {
      setTaxSystemsList(dataTaxSystems?.result || [])
    }
  }, [dataTaxSystems?.result])

  useEffect(() => {
    if (dataTaxSystems?.errorMessage || isErrorTaxSystems) {
      message.error(dataTaxSystems?.errorMessage || 'Ошибка загрузки систем налогообложения')
    }
  }, [isErrorTaxSystems, dataTaxSystems?.errorMessage])

  if (isSzContent || isResearcher || isSzOperator || isSzMentor) return null

  return (
    <div ref={wrapperRef}>
      <Form.Item
        name={['personalData', profileScreen.input.taxSystem.name]}
        label={profileScreen.input.taxSystem.label}
        rules={[{ required: true, message: profileScreen.input.taxSystem.message }]}
      >
        <Select
          dropdownClassName='tax-system'
          size='large'
          placeholder={profileScreen.input.taxSystem.placeholder}
          loading={isLoadingTaxSystems}
          open={open}
          onClick={(e) => {
            e?.target?.id !== 'tax-system-input' && setOpen(!open)
          }}
          disabled={isDisabled}
          dropdownRender={(menu) => (
            <>
              {menu}
              <Divider
                style={{ margin: '8px 0' }}
              />
              <Space
                style={{ padding: '0 8px 4px' }}
              >
                <Input
                  placeholder='ИП иная система налогообложения'
                  id='tax-system-input'
                  value={name}
                  onChange={onNameChange}
                />
                <Button type='text' onClick={addItem}>
                  Применить
                </Button>
              </Space>
            </>
          )}
        >
          {
            taxSystemsList.map(c => <Option key={c} value={c}>{c}</Option>)
          }
        </Select>
      </Form.Item>
    </div>
  )
}
